/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Confirmation_Prohibited_HintInputs */



/**
* | output |
* | --- |
* | "Reads and answers, never changes anything." |
*
* @param {Agent_Builder_Confirmation_Prohibited_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_confirmation_prohibited_hint = /** @type {((inputs?: Agent_Builder_Confirmation_Prohibited_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Confirmation_Prohibited_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Liest und antwortet, ändert nie etwas.")
	return /** @type {LocalizedString} */ ("Reads and answers, never changes anything.")
});